import { FormFields } from '../../core/forms';
import { FiedName, fieldLabel } from '../../core/labels';
import { injectTSDI } from '../../core/tsdi';
import { I18nStore } from '../../core/i18n-store';
import { hasTextBlockPrefix } from '../../core/text-block-util';

const getFieldLabel = (fieldName: string) => {
    const { translate } = injectTSDI(I18nStore);
    const label = fieldLabel(fieldName as FiedName) ?? fieldName;

    if (hasTextBlockPrefix(fieldName)) {
        return translate('onlinepages.agreement.checkbox');
    }

    switch (fieldName) {
        case 'day':
        case 'month':
        case 'year':
            return `${translate('customer.day.of.birth')} (${label})`;
        default:
            return label;
    }
};

export const getInvalidFields = (formFields: FormFields<unknown>) => {
    const usedLabels: string[] = [];

    return formFields.flatMap((entry) => {
        const fieldName = entry[0];
        const { error } = entry[1];

        if (!error) {
            return [];
        }

        const label = getFieldLabel(fieldName);

        if (usedLabels.includes(label)) {
            return [];
        }
        usedLabels.push(label);

        return [
            {
                label,
                error
            }
        ];
    });
};
